import MagicLink from "./MagicLink";

export default MagicLink;
